<template>
  <div>
     <header>
          <div class="headerOne">
                <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)"> -->
              <span class="buss">账户与安全</span>
          </div>
      </header>
      <div class="ulOne">
          <ul>
              <li>
                  <span>会员名</span>
                  <span  id="textCaed">{{nick}}</span>
              </li>
               <li  @click="$router.push({path:'/numberChange'})">
                  <span>修改手机号码</span>
                  <span class="phone" style="">{{phoneNum}}</span>
                  <span class="box"><img src="../../assets/images/goOn.png"></span>
                </li>
              <!-- 先占时弹窗，接口出来后做判断跳转页面$router.push({path:'/pay'}); -->
              <li @click="openConfirm">
                <span>设置支付密码</span>
                <span class="box"><img src="../../assets/images/goOn.png" ></span>
              </li>
          </ul>
      </div>
  </div>
</template>
<script>
import { MessageBox } from 'mint-ui';
import {mapState} from 'vuex';
    export default{
     data(){
         return{
             msg:"anquan",
             nick:this.$store.state.person.nickName,
         }
     },
      computed:{
           wsWbsocket(){
                return this.$store.state.wsWbsocket;
                }
        },

   computed:{
       phoneNum(){
           var phoneNum =this.$store.state.phoneNum
         
           var phoneNum = phoneNum.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2");
            return phoneNum
          },
          identityCard(){
              let identityCard =this.$store.state.identityCard
              return identityCard  
          }
    },
       methods:{
              //     设置支付密码       
             openConfirm() {
                 console.log(this.identityCard)
                   if (this.identityCard=="") {
                      MessageBox.confirm('尚未绑定身份证,点击确定前去绑定', '提示').then(action=>{
                       this.$router.push(
                           { path:'/personage',
                             query:{
                                    identity:this.identityCard,
                    
                      }
                           }
                           
                           )
                     })
                      }else{
                         this.$router.push({path:'/pay',
                          query:{
                                    identity:this.identityCard,
                    
                      }
                         
                         }) 
                      }
               
               },
    }
 }
</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
#textCaed{
    float: right;
    display: inline-block;
    margin-left: 0;
    height: 1.2rem;
    width:3rem;
    white-space:nowrap;
   text-overflow:ellipsis;
   -o-text-overflow:ellipsis;
        overflow: hidden;
        text-align: right;
        margin-right: 1rem
}
.phone{
    display: inline-block;
    width: 2.44rem
}
 header{
    height:1.6rem;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.20);
    position: relative;
}
 .headerOne{
     font-size: 0;  
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.55rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
  .ulOne{
      color: rgba(0,0,0,0.99);
      font-size: 0.38rem
  }
  .ulOne ul li{
      height: 1.7rem;
      border-bottom: 1px solid rgba(0,0,0,0.20)
  }
  .box{
       margin-left:0 !important;
       display: inline-block;
       height: 1.7rem;
       line-height: 1.7rem;

  }
   .ulOne ul li img{
       height: 0.5rem;
       width: auto;
  
   }
  .ulOne ul li span{
      font-size: 0.55rem;
      line-height: 1.7rem;
      margin-left: 0.5rem
  }
  .ulOne ul li:nth-child(1) span:nth-child(2) {
      color: rgba(0,0,0,0.5);
      margin-left: 4.2rem
  }
  .ulOne ul li:nth-child(2) span:nth-child(2) {
      color: rgba(0,0,0,0.5);
      margin-left: 1.5rem;
      margin-right: 1rem;
  }
  .ulOne ul li:nth-child(3) img{
      margin-left:5rem
  }
</style>



// WEBPACK FOOTER //
// src/components/change/safety.vue